"use strict";

// Prices come exclusively from the saved catalog, never from the request.
function eventPackageSelections(service = {}, input = {}) {
  const fail = (message) => { throw new Error(message); };
  const ids = input.selectedExtraIds == null ? [] : input.selectedExtraIds;
  if (!Array.isArray(ids) || ids.length > 50 || ids.some(id => typeof id !== "string")) {
    fail("La selección de extras no es válida.");
  }
  const catalog = Array.isArray(service.extras) ? service.extras : (service.optionalExtras || []);
  const selectedExtras = [...new Set(ids)].map(id => {
    const row = catalog.find(extra => String(extra.id) === id && extra.enabled !== false);
    if (!row) fail("Uno de los extras ya no está disponible. Revisa tu selección.");
    const price = Number(row.price);
    if (row.price == null || row.price === "" || !Number.isFinite(price) || price < 0 || price > 100000) fail("El precio de un extra necesita revisión.");
    return { id, name: String(row.name || row.label || "Extra").slice(0, 160), price: Math.round(price * 100) / 100 };
  });
  if (['included','none'].includes(service.charactersMode) && Array.isArray(input.selectedCharacterIds) && input.selectedCharacterIds.length) {
    fail("Este paquete no permite personajes adicionales. Revisa tu selección.");
  }
  const includedCharacters = [
    ...(service.charactersMode !== 'choose_primary' && Array.isArray(service.includedCharacters) ? service.includedCharacters : []),
    ...(service.charactersMode === 'included' && Array.isArray(service.characters) ? service.characters.map(character=>character.name || character.id) : []),
  ]
    .map(name => String(name).trim().slice(0, 100)).filter(Boolean).slice(0, 20);
  return {
    ...(service.charactersMode === 'choose_primary' ? require('./eventCharacterSelectionV1').eventCharacterSelection(service,input) : {}),
    selectedExtraIds: selectedExtras.map(row => row.id),
    selectedExtras,
    extrasPrice: selectedExtras.reduce((sum, row) => sum + Math.round(row.price * 100), 0) / 100,
    includedCharacters: [...new Set(includedCharacters)],
  };
}

function eventDurationPrice(service, option, hours) {
  const priceType = option.priceType || option.pricingType || service.priceType || service.pricingType;
  if (['quote', 'cotizacion', 'cotización'].includes(priceType)) return 0;
  const tiers = Array.isArray(option.durationPrices) && option.durationPrices.length
    ? option.durationPrices
    : service.pricingMode === "duration_tiers" ? service.durationPricingTiers : null;
  if (tiers) {
    const tier = tiers.find(row => Number(row.hours) === Number(hours));
    if (!tier) throw new Error("Esta duración no tiene un precio configurado. Elige otra duración.");
    const price = Number(tier.price);
    if (tier.price == null || tier.price === "" || !Number.isFinite(price) || price < 0 || price > 100000) throw new Error("Revisa el precio configurado para esta duración.");
    return Math.round(price * 100) / 100;
  }
  // Preserve legacy proportional pricing until explicit duration prices exist.
  if (option.price == null || option.price === '' || !Number.isFinite(Number(option.price)) || Number(option.price) < 0) throw new Error('Esta experiencia tiene su tarifa pendiente. Elige otra opción o contacta al negocio.');
  return Number(option.price) > 0 ? Math.round(Number(option.price) / Math.max(1, Number(service.duration || 60)) * Math.round(Number(hours) * 60) * 100) / 100 : 0;
}

function eventDurationOptions(service, option) {
  const min = Math.max(0.5, Number(service.minHours || 0.5));
  const max = Math.min(24, Math.max(min, Number(service.maxHours || 2)));
  const tiers = Array.isArray(option?.durationPrices) && option.durationPrices.length ? option.durationPrices : service.pricingMode === "duration_tiers" ? service.durationPricingTiers : null;
  if (tiers) return [...new Set(tiers.map(row => Number(row.hours)).filter(hours => Number.isFinite(hours) && hours >= min && hours <= max && Number.isInteger(hours * 2)))].sort((a,b) => a-b);
  const hours=[]; for(let h=min;h<=max;h+=0.5) hours.push(h); return hours;
}

function eventPackagePreview(service, input) {
  try { return eventPackageSelections(service,input); }
  catch(error) { return {selectedExtraIds:[],selectedExtras:[],extrasPrice:0,includedCharacters:[],error:error.message}; }
}

module.exports = { eventPackageSelections, eventPackagePreview, eventDurationPrice, eventDurationOptions };
